import React, { useState } from "react"
import { injectIntl } from "react-intl"
import { withRouter } from "react-router-dom"
import ReactTooltip from "react-tooltip"
import Icon from "../../icon/icon.component"
import FeatureProtectionWrapperMain from "./featureProtectionWrapperMain.component"
import { messages, getMessage, handleClick } from "./helpers.jsx"
import ActionButton from "../../button/actionbutton.component.jsx"
import { Intl } from "../../../state/helpers/IntlProps"

type OwnProps = {
    isProtected: boolean
    protectionRule: boolean
    protectedClassName: string
    accountFeatureKey: string
    className: string
    children: JSX.Element
    showLock: boolean
    premium: boolean
    message: string
    callback: () => void
    onClose: () => void
    onClickProtected: () => void
    onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
    intl: Intl
}

const ActionButtonWrapper = (props: OwnProps) => {
    const [displayModal, setDisplayModal] = useState(false)
    const showLock = props.showLock ?? true

    const lockedItem = <span key={"tooltip-container-action-button"} data-tip
        data-for={"actionButtonLock-action-button"}>
        <button key={"action-button"} className={props.protectedClassName || "btn"} onClick={(e) => {
            handleClick(e, props, setDisplayModal)
        }}>
            <ReactTooltip place="top" className="actionButtonLock"
                id={"actionButtonLock-action-button"} type="warning" effect="solid" multiline={true}>
                {getMessage(props.message, props.intl.formatMessage(messages["update_subscription"]))}
            </ReactTooltip>
            <div className="d-inline-flex">
                {props.children}
                {showLock && <Icon value="lock" className="lock"/>}
            </div>
        </button>
    </span>

    const item = <ActionButton key={"action-button"} className={props.className} onClick={(e) => {
        props.onClick(e)
    }}>
        {props.children}
    </ActionButton>

    return (<>
        <FeatureProtectionWrapperMain
            protectionRule={props.protectionRule}
            accountFeatureKey={props.accountFeatureKey}
            isProtected={props.isProtected ?? true}
            displayModal={displayModal}
            premium={props.premium}
            lockedItem={lockedItem}
            message={props.message}
            item={item}
            callback={props.callback || function () {
                return
            }}
            onClickProtected={props.onClickProtected || function () {
                return
            }}
            onClose={() => {
                setDisplayModal(false)
                if (props.onClose) {
                    props.onClose()
                }
            }}
            onClick={props.onClick || function () {
                return
            }}
        >
        </FeatureProtectionWrapperMain>
    </>)


}

export default withRouter(injectIntl(ActionButtonWrapper))


// WEBPACK FOOTER //
// ./src/common/rich-text/feature-protection-wrappers/actionButtonWrapper.component.tsx